<template>
  <div
    class="pointer-events-auto relative flex w-[326px] gap-2.5 overflow-hidden rounded-r2 border-[0.5px] bg-neutral-50 p-spacing_9 shadow-lg"
    :key="id"
    :class="{
      'border-errors': type === 'error',
      'border-success-200': type === 'success',
      'border-action': type === 'info',
    }"
    @mouseenter="$emit('pauseTimer')"
    @mouseleave="$emit('resumeTimer')"
  >
    <CommonUIcons
      class="h-8 w-8 shrink-0"
      :name="type === 'success' ? 'ic-check' : 'ic-info'"
      :class="{
        'text-errors': type === 'error',
        'text-success-200': type === 'success',
        'text-action': type === 'info',
      }"
    />

    <div class="flex grow justify-between gap-2">
      <p class="font-secondary text-size_4 font-bold text-neutral-800">
        {{ message }}
      </p>
      <CommonUIcons
        class="h-8 w-8 shrink-0 cursor-pointer"
        name="ic-x"
        @click="$emit('close', id)"
      />
    </div>

    <div
      class="loader absolute bottom-0 left-0 h-1 transition-all duration-100"
      :class="{
        'bg-errors': type === 'error',
        'bg-success-100': type === 'success',
        'bg-action': type === 'info',
      }"
      :style="{ animationDuration: `${duration}ms` }"
    />
  </div>
</template>

<script setup lang="ts">
import type { ToastProps } from "~/types/schemas/common/Atom/toaster";

defineEmits<{
  close: [id: number];
  pauseTimer: [];
  resumeTimer: [];
}>();

defineProps<ToastProps>();
</script>
